import { render, staticRenderFns } from "./BaseInputTag.vue?vue&type=template&id=77bde008"
import script from "./BaseInputTag.vue?vue&type=script&lang=js"
export * from "./BaseInputTag.vue?vue&type=script&lang=js"
import style0 from "./BaseInputTag.vue?vue&type=style&index=0&id=77bde008&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports